import React, {useEffect, useState} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loading() {
    const [opacity, setOpacity] = useState(0)
        
    useEffect(() => {
        setTimeout(() => {
            setOpacity(1)
        }, 500)
    }, [])
        
    return (
        <Box sx={{ position: 'absolute', display: 'flex', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.5)' }}>
            <CircularProgress size={42} sx={{ margin: 'auto', color: 'primary.main' }} />
        </Box>
    );
}